import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import { userInfoReducer, UserInfoEffects } from './store';
import { USER_INFO_FEATURE_NAME } from './store/feature-name';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(USER_INFO_FEATURE_NAME, userInfoReducer),
    EffectsModule.forFeature([ UserInfoEffects ]),
  ],
})
export class UserInfoModule {}
